export const BKJ_J360_VERSION: string = '10.3.0';
